import React, { useState } from 'react'

const ERROR_IMG_SRC =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4K'

export function ImageWithFallback(props: React.ImgHTMLAttributes<HTMLImageElement>) {
  const [didError, setDidError] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleError = () => {
    setDidError(true)
  }

  const { src, alt, style, className, ...rest } = props

  // The image source to display — either original or fallback
  const displaySrc = didError ? ERROR_IMG_SRC : src
  const originalSrc = src // Used in modal

  // Modal backdrop and content
  const openModal = () => setIsModalOpen(true)
  const closeModal = () => setIsModalOpen(false)

  if (didError) {
    return (
      <>
        <div
          className={`inline-block bg-gray-100 text-center align-middle cursor-pointer ${className ?? ''}`}
          style={style}
          onClick={openModal}  
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && openModal()}
        >
          <div className="flex items-center justify-center w-full h-full">
            <img
              src={displaySrc}
              alt={alt || "Error loading image"}
              {...rest}
              data-original-url={originalSrc}
              className="max-w-full max-h-full object-contain p-2"
              aria-label="Click to view large version"
            />
          </div>
        </div>

        {isModalOpen && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4"
            onClick={closeModal}
            aria-modal="true"
            role="dialog"
            aria-label="Large image viewer"
          >
            <div className="relative max-w-full max-h-full">
              <button
                onClick={closeModal}
                className="absolute -top-10 -right-4 text-black text-3xl font-bold hover:text-gray-300 transition-colors"
                aria-label="Закрыть"
              >
                ×
              </button>
              <img
                src={displaySrc}
                alt={alt || "Error loading image"}
                className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
                onLoad={(e) => e.currentTarget.classList.remove('opacity-0')}
              />
            </div>
          </div>
        )}
      </>
    )
  }

  return (
    <>
      <img
        src={src}
        alt={alt}
        className={`cursor-pointer ${className ?? ''}`}
        style={style}
        {...rest}
        onError={handleError}
        onClick={openModal} // 👈 Click to view large original image
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && openModal()}
        aria-label="Click to view large version"
      />

      {isModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75 p-4"
          onClick={closeModal}
          aria-modal="true"
          role="dialog"
          aria-label="Large image viewer"
        >
          <div className="relative max-w-full max-h-full">
            <button
              onClick={closeModal}
              className="absolute -top-10 -right-4 text-black text-3xl font-bold hover:text-gray-300 transition-colors"
              aria-label="Close modal"
            >
              ×
            </button>
            <img
              src={originalSrc}
              alt={alt || "Large image"}
              className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl"
              onLoad={(e) => e.currentTarget.classList.remove('opacity-0')}
              
            />
          </div>
        </div>
      )}
    </>
  )
}